import { useState, useEffect } from 'react';
import { Dimensions } from 'react-native';

const MOBILE_BREAKPOINT = 640;
const TABLET_BREAKPOINT = 1024;

export enum ViewType {
  DESKTOP,
  MOBILE = MOBILE_BREAKPOINT,
  TABLET = TABLET_BREAKPOINT,
}
/**
 * Returns the Window's width and height
 */
export function useWindowSize() {
  const [width, setWidth] = useState<number>();
  const [height, setHeight] = useState<number>();

  useEffect(() => {
    const windowSize = Dimensions.get('window');

    setHeight(windowSize.height);
    setWidth(windowSize.width);
  }, []);

  return [width, height];
}
/**
 * Indicates whether view is best suited for mobile, tablet or desktop
 */
export function useViewType() {
  const [width] = useWindowSize();

  if (width < ViewType.MOBILE) {
    return ViewType.MOBILE;
  } else if (width < ViewType.TABLET) {
    return ViewType.TABLET;
  }

  return ViewType.DESKTOP;
}
